@if (profile(); as profile) {
  @let userImageData = profile.userData.type === UserType.IdentityUser ? profile.userData.image : null;

  <mp-avatar
    [size]="size() === 'small' ? 'tiny' : 'medium'"
    [name]="profile.name"
    [image]="userImageData | mpkUserImage"
  />

  @if (size() === 'large') {
    <div class="profile-user">{{ profile.name }}</div>
    <div class="profile-organization">{{ profile.activeOrganization?.name }}</div>
  }
}
